module.exports = __webpack_public_path__ + "static/media/perspective-man-couch.d11aa27b.jpg";